module.exports = __webpack_public_path__ + "static/media/print.caac2937.svg";